import React from "react";
import { parseDate } from "@Util/moment.util";
import { Card, Grid, Typography } from '@curves/ui-base';

import ReadTextField from "@Local/Components/ReadTextField";
const ConsumerSectionByRead = props => {
	const { clubName, memberName, cellPhone, memberNo, birthday } = props;
	return (
		<Card>
			<Card.CardHeader
				title={
					<Typography variant="body-1" className="font-weight-900">
						訂購人資訊
					</Typography>
				}
				className="bg-black"
			/>
			<Card.CardContent className="p-4">
				<Grid spacing={3} container>
					<Grid xs={4} item>
						<ReadTextField label="所屬店鋪">{clubName}</ReadTextField>
					</Grid>
					<Grid xs={4} item>
						<ReadTextField label="會員姓名">{memberName}</ReadTextField>
					</Grid>
					<Grid xs={4} item>
						<ReadTextField label="手機/電話">{cellPhone}</ReadTextField>
					</Grid>
					<Grid xs={4} item>
						<ReadTextField label="會員編號">{memberNo}</ReadTextField>
					</Grid>
					<Grid xs={4} item>
						<ReadTextField label="生日">{birthday ? parseDate(birthday) : null}</ReadTextField>
					</Grid>
				</Grid>
			</Card.CardContent>
		</Card>
	);
};
export default ConsumerSectionByRead;
